import http from '~/utils/http'
import type { TeacherPerformance } from '~/features/performance/model'

export async function getTeacherPerformances(year: number, month: number): Promise<TeacherPerformance[]> {
  const response = await http.get<TeacherPerformance[]>('/admin/teacher-performance', { params: { year, month } })
  return response.data
}
export async function getTeacherPerformance(teacherId: string, year: number, month: number): Promise<TeacherPerformance> {
  const response = await http.get<TeacherPerformance>(`/admin/teacher-performance/${encodeURIComponent(teacherId)}`, { params: { year, month } })
  return response.data
}
